// External libraries
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { Zocdoc } from '@zocdoc-frontend-common/assets-icons';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const StyledZocdocIcon = styled(Zocdoc)`
    margin-left: 3px;
`;

const PoweredByZocdoc = ({ component: Tag = 'div', ...props }) => (
    <Tag {...props} href={Tag === 'a' ? 'https://zocdoc.com' : undefined}>
        powered by
        <StyledZocdocIcon color="currentColor" height={12} />
    </Tag>
);

PoweredByZocdoc.propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

const StyledPoweredByZocdoc = styled(PoweredByZocdoc)`
    display: inline-flex;
    align-items: baseline;
    font: 7.5px/1 ${FontFamily.SharpSansMedium};
    pointer-events: ${p => (p.component === 'a' ? 'auto' : 'none')};
    width: 120px;
    white-space: nowrap;
`;

export { StyledPoweredByZocdoc as default, StyledPoweredByZocdoc };
